import { render, staticRenderFns } from "./user-settings-layout.vue?vue&type=template&id=418c3951&scoped=true"
import script from "./user-settings-layout.vue?vue&type=script&lang=js"
export * from "./user-settings-layout.vue?vue&type=script&lang=js"
import style0 from "./user-settings-layout.vue?vue&type=style&index=0&id=418c3951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c3951",
  null
  
)

export default component.exports